"use strict";

var PropTypes = require("prop-types");

var classNames = require("classnames");
var LoggerInstance = require("js-logger").get("UseOnDaySelector");

var BootstrapPrompt = require("../shared/BootstrapPrompt");
var HtmlHelper = require("../shared/HtmlHelper");

var ProjectActions = require("./ProjectActions");
var PledgeActions = require("../actions/PledgeActions");
var ProjectConstants = require("./ProjectConstants");
var ProjectStore = require("./ProjectStore");

var TokenStore = require("../client/TokenStore");
var VisibilityStore = require("../client/VisibilityStore");

class UseOnDaySelector extends React.Component {
	constructor(props) {
		super(props);

		var selectedUseOnDay = null;
		var project = props.project;
		var useOnDays = props.useOnDays || [];
		var wizardUseOnDays = { allowedUseOnDays: [] };
		var useOnDay;
		var tangibleCode;
		var allowedUseOnDays = [];

		// If we are on the client side
		if (typeof (window) !== "undefined") {
			var projectStoreState = ProjectStore.getState();

			// Ideally we would get the project from the store, but that does not exist on the server
			// We optimistically render on the server with the props.project (the @Model) and on the
			//  client, we will get the project from the store
			project = projectStoreState.project || props.project || {};
			project = JSON.parse(JSON.stringify(project)); // clone the project to avoid reference
			useOnDays = props.useOnDays ? props.useOnDays.slice(0) : []; // clone the array to avoid reference

			// We only want to set the initial state from the store if we're not in a repeater.
			if (!props.context) {
				selectedUseOnDay = projectStoreState.selectedUseOnDay;
			}

			wizardUseOnDays = projectStoreState.wizardUseOnDays;
			if (wizardUseOnDays) {
				allowedUseOnDays = wizardUseOnDays.allowedUseOnDays || [];
			}
		}

		if (allowedUseOnDays) {
			for (var i = useOnDays.length - 1; i >= 0; --i) {
				useOnDay = useOnDays[i];
				var allowedIndex = allowedUseOnDays.indexOf(useOnDay.value);
				if (allowedIndex === -1) {
					// UseOnDay is not allowed
					useOnDays.splice(i, 1);
				} else if (useOnDay.useDefaultDescription) {
					// UseOnDay should use default description
					useOnDay.description = wizardUseOnDays[`${useOnDay.value}_Description`];
				}
			}
		}

		if (!selectedUseOnDay) {
			selectedUseOnDay = useOnDays.length > 0 ? useOnDays[0].value : "";
		}

		if (props.context) {
			if (props.project) {
				tangibleCode = props.project.tangibleCode;
			} else if (props.isDesignMode) {
				tangibleCode = project["ProjectCode"];
			}
		}

		this.state = {
			selectedUseOnDay,
			project,
			tangibleCode,
			useOnDays
		};

		this._onChange = this._onChange.bind(this);
	}

	handleUseOnDaySelected(event) {
		var selectedUseOnDay = event.currentTarget.value;

		ProjectActions.setUseOnDay(selectedUseOnDay, this.state.tangibleCode, this.props.pledgeCode, this.state.context);
	}

	elementsToShowHide(contextId, $context) {
		if (contextId) {
			var $useOnDaySelector = $(ReactDOM.findDOMNode(this));
			return $useOnDaySelector.closest("[data-component='category.project'],[data-component='category.pledge'],[data-component='searchResults.project'],[data-component='searchResults.pledge']").find("[data-component$='UseOnDay']");
		}
		return $context.find("[data-component$='UseOnDay']").not("[data-component='category.pledge'] [data-component$='UseOnDay'],[data-component='category.project'] [data-component$='UseOnDay'],[data-component='searchResults.pledge'] [data-component$='UseOnDay'][data-component='searchResults.project'] [data-component$='UseOnDay']");
	}

	elementsToUpdateToken(contextId, $context) {
		if (contextId) {
			var $useOnDaySelector = $(ReactDOM.findDOMNode(this));
			return $useOnDaySelector.closest("[data-component='category.pledge'],[data-component='category.project'],[data-component='searchResults.pledge'],[data-component='searchResults.project']").find("[data-placeholder='selectedUseOnDay']");
		}
		return $context.find("[data-placeholder='selectedUseOnDay']").not("[data-component='category.pledge'] [data-placeholder='selectedUseOnDay'],[data-component='category.project'] [data-placeholder='selectedUseOnDay'],[data-component='searchResults.pledge'] [data-placeholder='selectedUseOnDay'],[data-component='searchResults.project'] [data-placeholder='selectedUseOnDay']");
	}

	getUseOnDayDescription(useOnDayValue) {
		var useOnDayObject = this.state.useOnDays.find(useOnDay => useOnDay.value === useOnDayValue);
		if (useOnDayObject) {
			return useOnDayObject.description;
		}
		// TODO: should hide the element?
		return "ERROR: Token not found";
	}

	_onChange() {
		this.setState(ProjectStore.getState());
	}

	componentWillMount() {
		//Setting an instance Id, mainly for when we are in the searchResults and this component is in the grid and list view.  We need the names for the radio button groups to be unique.
		this.instanceId = HtmlHelper.getId($("body"));
	}

	componentDidMount() {
		var $useOnDay = $(ReactDOM.findDOMNode(this));
		var tangibleCode = this.state.tangibleCode;
		var { context, pledgeCode }  = this.props;
		var contextId = "";
		if (context) {
			contextId = this.getContextId($useOnDay, context);
			context =  this.getUpdatedContext(context);

			context += `_${contextId}`;
		}

		var ruleId = `useOnDay_${context}_${tangibleCode}`;
		var tokenId = `selectedUseOnDay_${context}_${tangibleCode}`;

		if (context) {
			ruleId = `useOnDay_${context}_${tangibleCode}`;
			tokenId = `selectedUseOnDay_${context}_${tangibleCode}`;

			if (pledgeCode) {
				ruleId = `${ruleId}_${pledgeCode}`;
				tokenId = `${tokenId}_${pledgeCode}`;
			}
		} else {
			ruleId = "useOnDay";
			tokenId = "selectedUseOnDay";
		}

		//For adding Visibility Rules only, we need to distinguish between grid and list view; otherwise, only one of them will be added as a rule.
		if ($useOnDay.parents(".grid-search-results-wrapper,.grid-category-items-wrapper").length) {
			ruleId += "_grid";
		} else if ($useOnDay.parents(".list-search-results-wrapper,.list-category-items-wrapper").length) {
			ruleId += "_list";
		}

		if (typeof ($) !== "undefined") {
			if (!VisibilityStore.hasRule(ruleId)) {
				VisibilityStore.addRule({
					identifier: ruleId,
					triggers: [ProjectConstants.SET_DONATION_FREQUENCY],
					shouldTrigger: (action) => {
						// Sub-criteria, cannot rely on SET_DONATION_FREQUENCY
						return action.context === context && action.tangibleCode === tangibleCode && (!pledgeCode || (!action.context || (action.pledgeCode && action.pledgeCode === pledgeCode)));
					},
					show: (action) => action.selectedFrequency !== "O",
					elements: this.elementsToShowHide.bind(this, contextId),
					initialize: () => {
						var selectedFrequency = ProjectStore.getSelectedFrequency(context, tangibleCode, pledgeCode);
						return selectedFrequency !== "O";
					}
				});
			}
			if (!TokenStore.hasRule(tokenId)) {
				TokenStore.addRule({
					identifier: tokenId,
					triggers: [ProjectConstants.SET_USE_ON_DAY],
					shouldTrigger: (action) => {
						// Sub-criteria, cannot rely on SET_DONATION_FREQUENCY
						return action.context === context && action.tangibleCode === tangibleCode && (!action.pledgeCode || action.pledgeCode === pledgeCode);
					},
					elements: this.elementsToUpdateToken.bind(this, contextId),
					getToken: (action) => this.getUseOnDayDescription(action.selectedUseOnDay),
					initialize: () => this.getUseOnDayDescription(ProjectStore.getSelectedUseOnDay(context, tangibleCode, pledgeCode))
				});
			}
		}

		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit wwwroot\js\designer\ExposedComponents.jsx
			parent.window.ComponentActions.childComponentLoaded(this);
		}

		var selectedUseOnDay = this.state.selectedUseOnDay;
		if (!context) {
			// Check sessionStorage for cachedValues
			var cachedValues = {};
			if ($useOnDay.parents(".create-recurring-use-on-date").length) {
				// We are on a pledge page
				if (PledgeActions.getCachedValues) {
					cachedValues = PledgeActions.getCachedValues() || {};
				}
			} else if (ProjectActions.getCachedValues) {
				cachedValues = ProjectActions.getCachedValues() || {};
			}

			selectedUseOnDay = cachedValues.useOnDay || this.state.selectedUseOnDay;
		}

		// At this point, selectedUseOnDay has been set by the component
		this.setState({ context, ruleId, tokenId }, () => {
			// This has to happen here so the onChange below is invoked
			ProjectActions.setUseOnDay(
				selectedUseOnDay,
				tangibleCode,
				this.props.pledgeCode,
				context
			);
		});
		ProjectStore.addChangeListener(this._onChange);
	}

	getContextId($component, context) {
		if (!context) {
			return;
		}

		switch (context) {
			case "tangible":
				return $component.closest("[data-component=category]").attr("id");
			case "result":
				return $component.closest("[data-component=searchResults]").attr("id");
		}
	}

	getUpdatedContext(context) {
		if (!context) {
			return;
		}

		switch (context) {
			case "tangible":
				return "category";
			case "result":
				return "search";
		}
	}

	componentWillUnmount() {
		var { context, tangibleCode, ruleId, tokenId } = this.state;
		var { pledgeCode } = this.props;

		VisibilityStore.removeRule(ruleId);
		TokenStore.removeRule(tokenId);
		ProjectStore.removeChangeListener(this._onChange);

		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit wwwroot\js\designer\ExposedComponents.jsx
			parent.window.ComponentActions.childComponentUnloaded(this);
			ProjectActions.setUseOnDay(null, tangibleCode, pledgeCode, context);
		}
	}

	renderButton(selectedUseOnDay) {
		var context = this.state.context;
		var name = `${context ? `useOnDay_${context}_${this.state.tangibleCode}` : "useOnDay"}_${this.instanceId}`;

		return (
			<div className="donation-use-on-days">
				{this.state.useOnDays.map((useOnDay) => {
					var isSelected = selectedUseOnDay === useOnDay.value;

					return (
						<label
								className={classNames(["useOnDay", "radio-button", this.props.childClass, { selected: isSelected }])}
								data-override-classes={this.props.childClass}
								key={useOnDay.value}
								data-component="ButtonUseOnDaySelector.button"
						>
							<input type="radio" name={name} value={useOnDay.value} onChange={this.handleUseOnDaySelected.bind(this)} checked={isSelected} />
							<span>{useOnDay.description}</span>
						</label>
					);
				})}
			</div>
		);
	}

	renderRadio(selectedUseOnDay) {
		var context = this.state.context;
		var name = `${context ? `useOnDay_${context}_${this.state.tangibleCode}` : "useOnDay"}_${this.instanceId}`;

		return (
			<div className="donation-use-on-days">
				{this.state.useOnDays.map((useOnDay) => {
					var isSelected = selectedUseOnDay === useOnDay.value;

					return (
						<label
								className={classNames(["useOnDay", this.props.childClass, { selected: isSelected }])}
								data-override-classes={this.props.childClass}
								key={useOnDay.value}
								data-component="RadioUseOnDaySelector.radio"
						>
							<input type="radio" name={name} value={useOnDay.value} onChange={this.handleUseOnDaySelected.bind(this)} checked={isSelected} />
							<span data-component="RadioUseOnDaySelector.radio.label">{useOnDay.description}</span>
						</label>
					);
				})}
			</div>
		);
	}

	renderDropdown(selectedUseOnDay) {
		return (
			<div>
				<select
						className={classNames(["donation-use-on-days", this.props.childClass])}
						style={this.props.isDesignMode ? {"pointerEvents": "none"} : undefined}
						data-override-classes={this.props.childClass}
						selected={selectedUseOnDay}
						onChange={this.handleUseOnDaySelected.bind(this)}
						data-component="SelectUseOnDaySelector.select"
						value={selectedUseOnDay || ""}
				>
					{this.state.useOnDays.map((useOnDay) => {
						return (
							<option className="useOnDay" key={useOnDay.value} value={useOnDay.value}>
								{useOnDay.description}
							</option>
						);
					})}
				</select>
			</div>
		);
	}

	renderContainer() {
		var selectedUseOnDay;
		if (this.state.context) {
			selectedUseOnDay = ProjectStore.getSelectedUseOnDay(this.state.context, this.state.tangibleCode, this.props.pledgeCode);
		} else {
			selectedUseOnDay = this.state.selectedUseOnDay;
		}

		switch (this.props.type) {
			case "button":
				return this.renderButton(selectedUseOnDay);
			case "radio":
				return this.renderRadio(selectedUseOnDay);
			case "dropdown":
				return this.renderDropdown(selectedUseOnDay);
			default:
				console.error("Invalid type for UseOnDaySelector");
				return null;
		}
	}

	render() {
		var useOnDays = this.state.useOnDays;
		var reactComponentName;

		switch (this.props.type) {
			case "button":
				reactComponentName = "ButtonUseOnDaySelector";
				break;
			case "radio":
				reactComponentName = "RadioUseOnDaySelector";
				break;
			case "dropdown":
				reactComponentName = "SelectUseOnDaySelector";
				break;
			default:
				console.error("Invalid type for UseOnDaySelector");
				return null;
		}

		return (
			<div
				data-react-component-name={reactComponentName}
				data-react-component-category="ProjectComponents"
				data-component-id={this.props.dataComponentId}
				data-nested-id={this.props.dataNestedId}
				data-repeated-id={this.props.dataRepeatedId}
				data-theme={+this.props.theme ? this.props.theme : undefined}
				data-custom={this.props.isCustomTheme || null}
				data-child-of={this.props.dataChildOf}
			>
				{useOnDays && useOnDays.length > 0 ?
					this.renderContainer()
				:
					<div className="collapsedComponentPlaceholder">Use On Day Selector</div>
				}
			</div>
		);
	}
}

UseOnDaySelector.defaultProps = {
	type: "button",
	theme: "0",
	isCustomTheme: false
};

UseOnDaySelector.propTypes = {
	isDesignMode: PropTypes.bool,
	project: PropTypes.object,
	pledgeCode: PropTypes.string,
	useOnDays: PropTypes.array,
	type: PropTypes.oneOf(["button", "radio", "dropdown"]).isRequired,
	theme: PropTypes.string,
	context: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	childClass: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string
};

module.exports = UseOnDaySelector;
